const OPTION_LABEL_PREFIX = '[Option] ';

// Quotation document label of a service usages group: the optional groups
// (quotation options chosen or not by the client) are prefixed.
export const formatQuotationGroupLabel = ({
  isOptional,
  label,
}: Readonly<{ isOptional: boolean; label: string | null }>): string | null =>
  isOptional ? `${OPTION_LABEL_PREFIX}${label ?? ''}` : label;
